import { render, staticRenderFns } from "./FeaturedDormsNoTabs.vue?vue&type=template&id=8a6ac42c&scoped=true&"
import script from "./FeaturedDormsNoTabs.vue?vue&type=script&lang=js&"
export * from "./FeaturedDormsNoTabs.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedDormsNoTabs.vue?vue&type=style&index=0&id=8a6ac42c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6ac42c",
  null
  
)

export default component.exports